import { Empty } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";

export default function ListPage({ kjList }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  
  const getkjNodes = () => {
    const nodes = [];
    for (const data of kjList) {
      const node = (
        <div
          key={data.id}
          className="bg-neutral-900 rounded-xl p-4 mb-4 shadow-card hover:shadow-lg transition-shadow cursor-pointer"
          onClick={() => {
            navigate("/lockUpInfo/" + data.id);
          }}
        >
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center">
              <img
                alt=""
                src={imageConfig.baseImageUrl+data.imgs}
                className="w-10 h-10 rounded-full mr-3"
              />
              <span className="text-white font-medium">{data.title}</span>
            </div>
            <button className="bg-gradient-primary px-4 py-1.5 rounded-lg text-black text-sm hover:opacity-90 transition-opacity">
              {translate(getText("去買入"))}
            </button>
          </div>
          
          <div className="grid grid-cols-3 gap-4">
            <div className="text-center">
              <div className="text-neutral-400 text-xs mb-1">
                {translate(getText("單筆限額"))}
              </div>
              <div className="text-white text-sm">
                {data.min}~{data.max}
              </div>
            </div>
            <div className="text-center border-l border-r border-neutral-700">
              <div className="text-neutral-400 text-xs mb-1">
                {translate(getText("日收益率"))}
              </div>
              <div className="text-success text-sm font-medium">
                {data.dayoutnum}%
              </div>
            </div>
            <div className="text-center">
              <div className="text-neutral-400 text-xs mb-1">
                {translate(getText("周期"))}
              </div>
              <div className="text-white text-sm">
                {data.cycle}{translate(getText("(天)"))}
              </div>
            </div>
          </div>
        </div>
      );
      nodes.push(node);
    }
    
    if (nodes.length === 0) {
      nodes.push(
        <div className="flex justify-center items-center py-8">
          <Empty description={translate(getText("暂无更多了"))} />
        </div>
      );
    }
    return nodes;
  };
  
  return (
    <div className="p-4">
      {getkjNodes()}
    </div>
  );
}
